import React from "react";
import { useTranslation } from "react-i18next";

const TextSwitchButton = ({
  isChecked,
  firstValue,
  secondValue,
  handleToggleSwitch,
}) => {
  const { t } = useTranslation();
  return (
    <div className="switch">
      <input
        id="role-toggle"
        className="role-toggle role-toggle-round-flat"
        type="checkbox"
        checked={isChecked}
        onChange={handleToggleSwitch}
      />
      <label htmlFor="role-toggle"></label>
      <span className="on text-capitalize">{t(firstValue)}</span>
      <span className="off text-capitalize">{t(secondValue)}</span>
    </div>
  );
};

export default TextSwitchButton;
